import { Component, ViewEncapsulation } from "@angular/core";
import { Tab } from "../../models/tab";
import { AdminService } from "../../services/admin.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-proxy",
  templateUrl: "./proxy.component.html",
  styleUrls: ["./proxy.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class ProxyComponent {
  loading: boolean;
  tabs: Tab[];

  /**
   * Initialize proxy to redirect user after login
   * @param {AdminService} adminService
   * @param {Router} router
   */
  constructor(private adminService: AdminService, private router: Router) {
    this.tabs = [];
    this.loading = true;
    this.adminService.init().subscribe(() => {
      this.tabs.push(
        new Tab({
          icon: "speaker_notes",
          title: "Program Articles",
          link: "/program-articles",
          componentNames: [
            "Program Article Digital",
            "Program Article Press",
            "Program Article Popup Next",
            "Program Article Partners",
          ],
          visibility:
            this.adminService.can("Program Article Digital", "View") ||
            this.adminService.can("Program Article Press", "View") ||
            this.adminService.can("Program Article Popup Next", "View") ||
            this.adminService.can("Program Article Partners", "View"),
        })
      );
      this.tabs.push(
        new Tab({
          icon: "directions_run",
          title: "Event Article",
          link: "/event-article",
          componentNames: ["Event Article"],
          visibility: this.adminService.can("Event Article", "View"),
        })
      );
      this.tabs.push(
        new Tab({
          icon: "translate",
          title: "Translate",
          link: "/translate",
          componentNames: ["Translate"],
          visibility: this.adminService.can("Translate", "View"),
        })
      );
      this.tabs.push(
        new Tab({
          icon: "flash_on",
          title: "Magic Box",
          link: "/magicbox",
          componentNames: [
            "Magic Box Digital",
            "Magic Box Press",
            "Magic Box Popup Next",
            "Magic Box Partners",
          ],
          visibility:
            this.adminService.can("Magic Box Digital", "View") ||
            this.adminService.can("Magic Box Press", "View") ||
            this.adminService.can("Magic Box Popup Next", "View") ||
            this.adminService.can("Magic Box Partners", "View"),
        })
      );
      this.tabs.push(
        new Tab({
          icon: "adjust",
          title: "TNT Sports",
          link: "/tnt-sports",
          componentNames: ["TNT Sports"],
          visibility: this.adminService.can("BT Sport", "View"),
        })
      );
      this.tabs.push(
        new Tab({
          icon: "security",
          title: "Admin",
          link: "/admin",
          componentNames: ["Admin Panel"],
          visibility: this.adminService.can("Admin Panel", "View"),
        })
      );
      this.tabs = this.tabs.filter((tab) => tab.visibility);
      if (this.tabs.length > 0) {
        this.router.navigateByUrl(this.tabs[0].link);
      } else {
        this.loading = false;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/proxy/proxy.component.ts